import { useRef } from 'react';

import { useModal } from 'mui-modal-provider';

import { Cluster } from '@cast/types';

import { AssignSecurityCredentialsDialog } from './AssignSecurityCredentialsDialog';

import { useCluster } from '@cast/shared-cluster-context-data-access';

import { ShowModalOutput } from '@cast/design-system';

type Props = {
  cluster?: Cluster;
  onEnabled?: () => void;
};

export const useAssignSecurityCredentialsDialog = ({
  cluster: clusterProp,
  onEnabled,
}: Props = {}) => {
  const modalRef = useRef<ShowModalOutput>(undefined);
  const { cluster } = useCluster();
  const { showModal } = useModal();

  const destroy = () => {
    modalRef.current?.destroy();
  };

  const openAssignSecurityCredentialsDialog = () => {
    modalRef.current = showModal(
      AssignSecurityCredentialsDialog,
      {
        cluster: clusterProp ?? cluster,
        destroy,
        onEnabled,
      },
      { rootId: 'root' }
    );
  };

  return { openAssignSecurityCredentialsDialog };
};
